export enum RewindActionTypes {
  GET_REWIND_REQUEST = 'rewind/GET_REWIND_REQUEST',
  GET_REWIND_SUCCESS = 'rewind/GET_REWIND_SUCCESS',
  GET_REWIND_ERROR = 'rewind/GET_REWIND_ERROR',
  UPLOADING = 'rewind/UPLOADING',
  UPLOADED = 'rewind/UPLOADED',
}
